import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion/Accordion";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection/AccordionSection";
import GridContainer from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridItem, Typography } from "@insite/mobius/index";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import Report from "@tKgpco/Components/MyAccount/Reports/Report";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    settings: state.context.settings,
    isSecurityRolesAssigned: state.context.session?.properties?.isSecurityRolesAssigned?.toLowerCase() === "true",
    featureWidgets: state.context.session.properties?.featureWidgets?.split(",").map(page => page.trim()) || [],
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface ReportsStyles {
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
    poLineTitleGridItem?: GridItemProps;
    packingSlipTitleGridItem?: GridItemProps;
    centeringWrapper?: InjectableCss;
    loadingSpinner?: LoadingSpinnerProps;
    title?: TypographyPresentationProps;
    titleContainer?: GridItemProps;
}

export const reportsStyles: ReportsStyles = {
    accordionSection: {
        panelProps: {
            css: css`
                > div {
                    border-bottom: 1px solid lightgrey;
                    padding-bottom: 15px;
                    margin-bottom: 15px;
                    &:last-of-type {
                        border: none;
                        margin-bottom: 0;
                    }
                }
            `,
        },
    },

    centeringWrapper: {
        css: css`
            display: flex;
            height: 150px;
            justify-content: center;
            align-items: center;
        `,
    },

    titleContainer: {
        width: 12,
    },

    title: {
        weight: "bold",
        css: css`
            font-size: ${TYPOGRAPHY.size.larger};
        `,
    },
};

const styles = reportsStyles;

const reports = [
    {
        id: uniqueId(),
        title: "Purchase History Report",
        type: "purchaseHistory",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
        isConfigurable: true,
    },
    {
        id: uniqueId(),
        title: "Back Ordered Items Report",
        type: "backOrderedItem",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
        isConfigurable: false,
    },
    {
        id: uniqueId(),
        title: "Discrepancy Report",
        type: "discrepancyReports",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
        isConfigurable: true,
    },
    {
        id: uniqueId(),
        title: "RMA Report",
        type: "rmaReports",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
        isConfigurable: true,
    },
    {
        id: uniqueId(),
        title: "Item Tracking Report",
        type: "itemTrackingReports",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
        isConfigurable: true,
    },
].sort((a, b) => a.title.localeCompare(b.title));

const Reports: FC<Props> = ({ id, fields, settings, history, featureWidgets, isSecurityRolesAssigned }) => {
    const { properties } = settings;
    if (properties.backOrderedItemsReportsType === "OFF" && properties.purchaseHistoryReportsType === "OFF") {
        history.push("/MyAccount");
    }
  
    return (
        <Accordion {...styles.accordion} headingLevel={3}>
            <ManagedAccordionSection
                title={
                    <GridContainer>
                        <GridItem {...styles.titleContainer}>
                            <Typography as="h2" {...styles.title}>
                                {translate("Reports")}
                            </Typography>
                        </GridItem>
                    </GridContainer>
                }
                initialExpanded={true}
                {...styles.accordionSection}
            >
                {reports
                    .filter(report => {
                        if (report.type === "backOrderedItem") {
                            return !(properties.backOrderedItemsReportsType === "OFF");
                        }
                        if (report.type === "purchaseHistory") {
                            return !(properties.purchaseHistoryReportsType === "OFF");
                        }
                        if (report.type === "discrepancyReports") {
                            return !(properties.discrepancyHistoryReportOption === "OFF");
                        }
                        if (report.type === "rmaReports") {
                            return !(properties.rmaHistoryReportOption === "OFF");
                        }
                        // if (report.type === "itemTrackingReports") {
                        //     return !(properties.itemTrackingReportsOption === "OFF");
                        // }

                        // if (featureWidgets?.includes("RMA Report") && report.type === "rmaReports") {
                        //     return false;
                        // }
                        // if (featureWidgets?.includes("Item Tracking Report") && report.type === "itemTrackingReports") {
                        //     return false;
                        // }
                        // if (featureWidgets?.includes("Discrepancy Report") && report.type === "discrepancyReports") {
                        //     return false;
                        // }

                        return true;
                    })
                    .map(report => {
                        switch (report.type) {
                            case "purchaseHistory":
                                report.description = fields.purchaseHistoryDescripition;
                                break;
                            case "discrepancyReports":
                                report.description = fields.discrepancyReportsDescripition;
                                break;
                            case "rmaReports":
                                report.description = fields.rmaReportsDescripition;
                                break;
                            case "itemTrackingReports":
                                report.description = fields.itemTrackingReportsDescripition;
                                break;
                            default:
                                report.description = fields.backOrderedItemDescripition;
                                break;
                        }
                        return <>
                        { !((featureWidgets?.includes("RMA Report") && report.type === "rmaReports") || (featureWidgets?.includes("Item Tracking Report") && report.type === "itemTrackingReports") || (featureWidgets?.includes("Discrepancy Report") && report.type === "discrepancyReports")) &&
                          <Report report={report} key={report.id} />
                        }
                        </>;
                    })}
            </ManagedAccordionSection>
        </Accordion>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(Reports)),
    definition: {
        displayName: "Reports",
        group: "Common",
        fieldDefinitions: [
            {
                name: "purchaseHistoryDescripition",
                displayName: "Purchase History Descripition",
                editorTemplate: "TextField",
                defaultValue:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
                fieldType: "Translatable",
            },
            {
                name: "backOrderedItemDescripition",
                displayName: "Back Order Item Descripition",
                editorTemplate: "TextField",
                defaultValue:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
                fieldType: "Translatable",
            },
            {
                name: "rmaReportsDescripition",
                displayName: "RMA Reports Descripition",
                editorTemplate: "TextField",
                defaultValue:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
                fieldType: "Translatable",
            },
            {
                name: "discrepancyReportsDescripition",
                displayName: "Discrepancy Reports Descripition",
                editorTemplate: "TextField",
                defaultValue:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
                fieldType: "Translatable",
            },
            {
                name: "itemTrackingReportsDescripition",
                displayName: "Item Tracking Reports Descripition",
                editorTemplate: "TextField",
                defaultValue:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
